<template>
  <v-app v-if="auth">
    <!-- Это когда пользователь заререген -->
    <AuthUser />

    <!-- <vFooter/> -->
  </v-app>
  <v-app v-else>
    <vue-confirm-dialog></vue-confirm-dialog>

    <!-- это на страницу логина -->
    <NotAuthUser />
  </v-app>
</template>

<script>
import {
  reconnectWebSocket,
  webSocketConnect,
} from "@/js/WebSocket.js";
//import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    AuthUser: () => import("@/components/AuthUser.vue"),
    NotAuthUser: () => import("@/components/NotAuthUser.vue"),
  },
  data: () => ({
    auth: true,
  }),
  methods: {
    hasUserData() {
      return localStorage.getItem("UserData") != null;
    },
    handleServiceWorkerMessage(event) {
      const data = event && event.data ? event.data : null;

      if (!data || data.type !== "OPEN_CHAT_FROM_PUSH") {
        return;
      }

      if (data.roomId) {
        this.$router.replace({
          name: "room",
          params: { roomId: String(data.roomId) },
        }).catch(() => {});
        return;
      }

      if (data.url) {
        this.$router.replace(String(data.url)).catch(() => {});
      }
    },
    handleAppVisible() {
      this.$store.commit("UpdateVisibilityTab", true);

      if (this.hasUserData()) {
        reconnectWebSocket();
      }
    },
    handleAppHidden() {
      this.$store.commit("UpdateVisibilityTab", false);
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.handleAppVisible();
      } else {
        this.handleAppHidden();
      }
    },
  },
  mounted() {
    /// окно в фокусе
    window.addEventListener("focus", this.handleAppVisible);

    window.addEventListener("blur", this.handleAppHidden);
    window.addEventListener("pageshow", this.handleAppVisible);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", this.handleServiceWorkerMessage);
    }

    if (document.visibilityState === "visible") {
      this.$store.commit("UpdateVisibilityTab", true);
      //console.log("вкладка активна");
    } else {
      this.$store.commit("UpdateVisibilityTab", false);
      //console.log("вкладка не активна");
    }

    // если нет токена выкидываем
    if (localStorage.getItem("UserData") == null) {
      this.auth = false;
    } else {
      /// если токен протух выкидываем
      let tokenTime = JSON.parse(localStorage.getItem("UserData")).payload.exp;
      let timeNow = Math.round(Date.now() / 1000);
      if (timeNow > tokenTime) {
        this.$confirm({
          title: "Внимание 🤚",
          message: "Заколчилось время сессии",
          button: {
            yes: "OK",
          },
        });

        //alert('Заколчилось время сессии');
        this.$store.commit("UpdateUserData");
        localStorage.removeItem("UserData");

        this.auth = false;
      }
    }

    if (localStorage.getItem("UserData") != null) {
      webSocketConnect();
    }

    /// токен для пуш
    // if (localStorage.getItem("fcm") == null) {
    //   const uid = uuidv4();
    //   localStorage.setItem("fcm", uid);
    // }

    /// узнаем свои данные и сверяем подразделение

    // let json = {
    //     'pathUrl': this.$store.state.urlPathAuth,  /// путь
    //     'method': 'post',
    //     'alert': false,
    //     'url': 'me',
    //     'loading': false,
    //     //'update': 'UpdateListService',
    //     'postData': {}
    //   }
    //   this.$store.dispatch('axiosData', json)
    //     .then(response => {

    //       if(response.data.department !== this.$store.state.UserData.department.id){

    //         alert('Судать вы дно!')
    //       }
    //       //console.log(response.data);
    //     })

    //this.getConfig();
    //this.getPermToEnterInService();
    //this.getDepartmentInfo(this.$store.state.UserData.user.department);
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.handleAppVisible);
    window.removeEventListener("blur", this.handleAppHidden);
    window.removeEventListener("pageshow", this.handleAppVisible);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("message", this.handleServiceWorkerMessage);
    }
  },
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
}

body {
  overflow: hidden;
}

.v-application,
.v-application--wrap {
  min-height: 100%;
}
</style>
